// extracted by mini-css-extract-plugin
export default {"btn":"DownloadButton_btn__UyFtK","disabled":"DownloadButton_disabled__3C1CU"};